<template>
  <div style="width: 100%; height: 100%; position: relative">
    <a :href='!noClick ?  "/ideen?kategorie=" + category + "&startMap=true&startLat=" + lat + "&startLng=" + lng : "https://www.google.de/maps"'>
      <div
        v-if="disabled || (this.lat == null && this.lng == null)"
        class="map-overlay"
      ></div>


      <GmapMap
        :center="{ lat: latDefault, lng: lngDefault }"
        :zoom="zoomLevel"
        :options="{
          styles: myStyle,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: false,
        }"
        :style="
          show
            ? 'width: 250px; height: 250px; border-radius: 6px'
            : 'width: 100%; height: 100%; border-radius: 6px'
        "
      >
        <gmap-custom-marker
          v-if="!neutral && this.lat != null && this.lng != null"
          :marker="{
            lat: latDefault,
            lng: lngDefault,
          }"
        >
          <img src="/map-marker.svg" />
        </gmap-custom-marker>
      </GmapMap>
    </a>
  </div>
</template>
<script>
import GmapCustomMarker from "vue2-gmap-custom-marker";

export default {
  // internal properties
  components: {
    "gmap-custom-marker": GmapCustomMarker,
  },
  props: ["lat", "lng", "neutral", "disabled", "show", "category", "noClick"],
  data() {
    return {
      position: {
        lat: parseFloat(this.lat),
        lng: parseFloat(this.lng),
      },
      myStyle: [
        {
          featureType: "administrative",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#0e5c84",
            },
          ],
        },
        {
          featureType: "landscape",
          elementType: "all",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "all",
          stylers: [
            {
              visibility: "simplified",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#fbc1ac",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
            {
              saturation: "0",
            },
            {
              lightness: "0",
            },
            {
              weight: "1",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "geometry",
          stylers: [
            {
              color: "#fff1eb",
            },
          ],
        },
        {
          featureType: "transit",
          elementType: "all",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "all",
          stylers: [
            {
              color: "#94dafd",
            },
            {
              visibility: "on",
            },
          ],
        },
      ],
    };
  },
  methods: {},
  mounted() {
    console.log(this.lat);
    console.log(this.lng);
  },
  computed: {
    zoomLevel: function () {
      return this.neutral || (this.lat == null && this.lng == null) ? 8 : 14;
    },
    latDefault: function () {
      return this.neutral || (this.lat == null && this.lng == null)
        ? 47.376888
        : parseFloat(this.lat);
    },
    lngDefault: function () {
      return this.neutral | (this.lat == null && this.lng == null)
        ? 8.541694
        : parseFloat(this.lng);
    },
  },
};
</script>
